if (!window.__giftMeterBound) {
  window.__giftMeterBound = true;

  let inFlight = false;

  const getDrawer = () => document.querySelector('cart-drawer');

  const shouldAutoRemove = () => Boolean(document.querySelector('[data-gift-autoremove]'));

  async function cartRequest(endpoint, payload) {
    const drawer = getDrawer();
    if (!drawer) return;

    payload.sections = drawer.getSectionsToRender().map((section) => section.id);
    payload.sections_url = window.location.pathname;

    const response = await fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    });

    const state = await response.json();
    drawer.renderContents(state);
  }

  async function autoRemoveGift() {
    if (inFlight) return;

    const marker = document.querySelector('[data-gift-autoremove]');
    if (!marker) return;

    const line = Number(marker.dataset.giftAutoremove);
    if (!line) return;

    marker.removeAttribute('data-gift-autoremove');
    inFlight = true;

    const drawer = getDrawer();
    const inner = drawer ? drawer.querySelector('.drawer__inner') : null;
    if (inner) {
      inner.style.transition = 'opacity 0.15s ease';
      inner.style.opacity = '0.5';
      inner.style.pointerEvents = 'none';
    }

    try {
      await cartRequest('/cart/change.js', { line: line, quantity: 0 });
    } catch (error) {
      console.error('Gift auto-remove failed:', error);
      if (inner) {
        inner.style.opacity = '';
        inner.style.pointerEvents = '';
      }
    } finally {
      inFlight = false;
    }
  }

  document.addEventListener('click', async (event) => {
    const addBtn = event.target.closest('[data-gift-add]');
    if (!addBtn || inFlight) return;

    addBtn.disabled = true;
    inFlight = true;

    try {
      await cartRequest('/cart/add.js', {
        items: [{ id: Number(addBtn.dataset.giftAdd), quantity: 1 }],
      });
    } catch (error) {
      console.error('Gift add failed:', error);
      addBtn.disabled = false;
    } finally {
      inFlight = false;
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    const drawer = getDrawer();
    if (drawer) {
      new MutationObserver(() => {
        if (shouldAutoRemove()) autoRemoveGift();
      }).observe(drawer, { childList: true, subtree: true });
    }
    autoRemoveGift();
  });
}